import { render, staticRenderFns } from "./CategoryPageLoader.vue?vue&type=template&id=4907ee4a&"
import script from "./CategoryPageLoader.vue?vue&type=script&lang=js&"
export * from "./CategoryPageLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports